import { Button, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Table from "../../../../components/Table";
import Search from "../../../../components/Search";
import withRouter from "../../../../withRouter";
import LeaveManagementPresenter from "../LeaveManagementPresenter";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import ModernizationForm from "./leave-management-form/ModernizationForm";

class ModernizationRequestPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LeaveManagementPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
    };
    this.state = {
      objects: [],
      object: {},
      type: [],
      isLeaveReqOpen: false,
      leavType: "",
      status: "",
      leaveType: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }
  async componentDidMount() {
    this.presenter.componentDidMount();
    const type = await findObjectUseCase().execute("leave_type", {
      where: { is_monetized: true },
    });
    this.setState({ type });
  }

  getCollectionName() {
    return "monetization_request";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleAddTraining() {
    this.setState({ isLeaveReqOpen: true, object: {} });
  }

  async handleEdit(objectID) {
    const object = await findObjectUseCase().execute("monetization_request", {
      where: { id: objectID },
    });
    this.setState({ object: object[0], isLeaveReqOpen: true });
  }

  getCurrent() {
    return this.getCurrentUser();
  }

  async onChangeForm(field, value) {
    this.setState({ [field]: value });
    if (field === "leavType") {
      this.onChangeFilter("String", value, "selectedType");
    } else {
      this.onChangeFilter("String", value, "stats");
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;
    if (!schema) return <Progress />;

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex gap-2">
                  <SearchSelect
                    value={this.state.status}
                    placeholder="Status"
                    onClickClear={() => this.onChangeForm("status", "")}
                    onChange={(value) => this.onChangeForm("status", value)}
                    options={[
                      ...["Approved", "Disapproved", "Pending"].map((item) => ({
                        label: item,
                        value: item,
                      })),
                    ]}
                  />
                  <SearchSelect
                    value={this.state.leavType}
                    placeholder="Leave Type"
                    onClickClear={() => this.onChangeForm("leavType", "")}
                    onChange={(value) => this.onChangeForm("leavType", value)}
                    options={[
                      ...this.state.type.map((type) => ({
                        label: type.name,
                        value: type.name,
                      })),
                    ]}
                  />
                  <Search
                    schemas={this.getSchemas()}
                    onSubmit={this.searchSubmit.bind(this)}
                    fields={schema.fields}
                  />
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}s</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.handleAddTraining.bind(this)}>
                        <i className="bi bi-plus-lg" /> New {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                objectId={this.handleEdit.bind(this)}
                // objectData={this.handleView.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  // {
                  //   label: <i className="bi bi-search"> View</i>,
                  //   actionType: "object",
                  // },
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "delete",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "updatedAt", "employee", "supervisor"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isLeaveReqOpen && (
          <ModernizationForm
            closeTrainingForm={() => this.setState({ isLeaveReqOpen: false })}
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
          />
        )}
      </>
    );
  }
}

export default withRouter(ModernizationRequestPage);
